import React from 'react';
import { Flex, TextV2 as Text } from '@withjoy/joykit';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';

export type GuestRating = 6 | 7 | 8 | 9;

interface UserRatingFacetProps {
  guestRatingsOptions: ReadonlyArray<{ rating: number; text: string }>;
  selectedRatings: ReadonlyArray<GuestRating>;
  guestRatingCounts: Record<string, number>;
  onRatingToggle: (rating: GuestRating) => void;
  title: string;
}

export const UserRatingFacet: React.FC<UserRatingFacetProps> = ({ guestRatingsOptions, selectedRatings, guestRatingCounts, onRatingToggle, title }) => {
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        {guestRatingsOptions.map(({ rating, text }) => (
          <StyledCheckboxV2
            key={rating}
            isChecked={selectedRatings?.includes(rating as GuestRating)}
            onChange={() => onRatingToggle(rating as GuestRating)}
            id={`guest-rating-${rating}`}
            isDisabled={!guestRatingCounts[rating]}
          >
            <Text
              typographyVariant="body1"
              color="mono14"
            >
              {text}
            </Text>
          </StyledCheckboxV2>
        ))}
      </Flex>
    </FilterFacet>
  );
};
